export default function initialUsers(users, roles, emptyTraduction) {
  let filteredUsers = [...users];
  filteredUsers = filteredUsers.filter((user) => {
    return roles.includes(user.profil);
  });
  if (emptyTraduction) {
    filteredUsers.unshift({
      decorator: {
        nomPrenom: emptyTraduction,
      },
      id: null,
    });
  }
  return filteredUsers;
}
